define('presentation/settings/webChats/viewModels/noWebChatPackageModalViewModel',[
    'common/promises/promiseFactory',
    'settings/navigationConfiguration'
], function() {
    return function (isBillingAdmin) {
        const self = this;

        const PromiseFactoryConstructor = require('common/promises/promiseFactory');
        const _promiseFactory = new PromiseFactoryConstructor();

        const _navigationConfiguration = require('settings/navigationConfiguration');

        self.isBillingAdmin = isBillingAdmin;
        self.plansUrl = _navigationConfiguration.routesById.plans.url;

        self.activate = () => {

            return _initialize();
        };

        const _initialize = () => {

            return _promiseFactory.wait();
        };
    };
});

